export default __webpack_public_path__ + "images/16_2_image.jpg";